import React from 'react';
import './EmptyState.css'; 

import { Button } from '../../components';
import { FaCar, FaCartArrowDown } from 'react-icons/fa';



const EmptyState = (props) => {

  // Destructure props with defaults
  const { 
    title = 'Your Cart is Empty', 
    message = 'Looks like you haven\'t added any items yet.',
    icon = 'cart',
    buttonText = 'shop now',
    buttonLink = 'Shop-List'
  } = props;

  // Function to determine which icon to display
  const getIcon = () => {
    switch(icon) {
      case 'compare':
        return <FaCar className='icon' />;
      case 'cart':
      default:
        return <FaCartArrowDown className='icon' />;
    }
  };

  return (
    <div className='empty-state'>

      {/* Display the appropriate icon */}
      <div>{getIcon()}</div>

      {/* Display the title */}
      <h3>{title}</h3>

      {/* Display the message */}
      <p className="empty-state-message">{message}</p>

      {/* Button for navigation */}
      <Button link={buttonLink} title={buttonText} />

    </div>
  );
};

export default EmptyState;